import EntityPillDropdown from './EntityPillDropdown';

export default EntityPillDropdown;
